const pascalCase = (input) => {
  const camelCased = input.replace(/(?:-|_)(\w)/g, (_, c) => {
    return c ? c.toUpperCase() : "";
  });
  return camelCased[0].toUpperCase() + camelCased.slice(1);
};
export {
  pascalCase
};
//# sourceMappingURL=pascalCase.js.map
